<script>
  import { onDestroy, onMount } from 'svelte';

  import Modal from '@components/Modal.svelte';
  import Viewport from '@components/Viewport.svelte';
  import Track from '@utils/track';
  import Notification from '@utils/notification';
  import { getCurrentUserStore } from '@stores/current_user';

  import Log from '@utils/log';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let recObjectsStore = getGroupStore('recObjectsStore');
  import { goto } from '$app/navigation';

  import Mobile from './Mobile.svelte';
  import Desktop from './Desktop.svelte';

  import jQuery from 'jquery';
  import queryString from 'query-string';

  export let recObjectId;
  export let showModal = false;
  export let showActionBar = true;
  export let showShareCard = true;
  export let showBookmark = true;
  export let customGroupStore;

  let group = customGroupStore || groupStore;
  let recObject = recObjectsStore.find(recObjectId);
  let currentUser = getCurrentUserStore('default');
  let notifLink = queryString.parse(location.search).notif;
  let commentLink = queryString.parse(location.search).comment_id;

  let unsubRecObject = recObject.subscribe((x) => {
    recObject = x;
  });

  let detailUrl = recObject.detail_url;
  let shareInput;

  let close = function () {
    if (notifLink || commentLink) {
      window.detailViewLoadedDirectly = false;
      showModal = false;
      goto(group.path);
    } else {
      history.back();
    }
  };

  let clearSelected = function () {
    if (window.getSelection) {
      window.getSelection().removeAllRanges();
    } else if (document.selection) {
      document.selection.empty();
    }
  };

  let getWeblinkOrAffilateUrl = function () {
    if (recObject.affiliate_url && recObject.affiliate_url != '') {
      return recObject.affiliate_url;
    } else {
      return recObject.weblink;
    }
  };

  let goToWeblink = function () {
    clearSelected();

    Track.detailviewWeblinkClicked({
      user: currentUser,
      group,
      recObject,
    });

    window.open(getWeblinkOrAffilateUrl());
  };

  let goToEmail = function () {
    clearSelected();

    Track.detailviewEmailClicked({
      user: currentUser,
      group,
      recObject,
    });

    location.href = `mailto:${recObject.email}`;
  };

  let goToInstagram = function () {
    clearSelected();

    Track.detailviewInstagramClicked({
      user: currentUser,
      group,
      recObject,
    });

    window.open(recObject.instagram_url);
  };

  let goToPhone = function () {
    clearSelected();

    Track.detailviewPhoneClick({
      user: currentUser,
      group,
      recObject,
    });

    location.href = `tel:${recObject.phone}`;
  };

  let pushDetailPathInHistory = function () {
    window.history.pushState(null, null, recObject.detail_path);
  };

  let changeUrlToDetailsView = function () {
    if (!notifLink) {
      let params = location.search;
      let detailId = queryString.parse(params).detail_id;

      if (window.detailViewLoadedDirectly) {
        window.history.replaceState(null, null, group.path);
        window.detailViewLoadedDirectly = false;
        pushDetailPathInHistory();
      }

      if (!detailId) {
        pushDetailPathInHistory();
      }
    }
  };

  let logCopyEvent = function () {
    Log.info(
      `SHARE: Card Link Copied - ${recObject.name1} (who shared: ${currentUser && currentUser.name}, list: ${
        recObject.detail_url
      })`
    );
  };

  let copyLinkForMobile = function () {
    if (typeof navigator !== 'undefined' && typeof navigator.share != 'undefined') {
      navigator
        .share({ title: recObject.name1, url: recObject.detail_url })
        .then(() => {})
        .catch(() => {});

      Track.detailviewShareClicked({
        user: currentUser,
        group,
        recObject,
      });

      logCopyEvent();
    } else {
      copyLinkForDesktop();
    }
  };

  let copyLinkForDesktop = function () {
    jQuery(shareInput).css('display', 'block');
    shareInput.select();
    shareInput.setSelectionRange(0, 9999);
    document.execCommand('copy');
    jQuery(shareInput).css('display', 'none');

    Notification.send({ text: 'Link copied' });

    Track.detailviewShareClicked({
      user: currentUser,
      group,
      recObject,
    });

    logCopyEvent();
  };

  let trackDetailView = function () {
    Track.detailViewSeen({ user: currentUser, group, recObject });
  };

  onMount(() => {
    changeUrlToDetailsView();
    trackDetailView();
  });

  onDestroy(() => {
    unsubRecObject();
  });
</script>

{#if showModal}
  <div class="svelte-modal detail-view-modal">
    <Viewport DESKTOP_MIN={1024} TABLET_MIN={640} let:tablet let:mobile let:desktop>
      {#if mobile || tablet}
        <Modal
          hide={close}
          style={mobile
            ? 'margin: 0px !important; padding-top: 0px !important; border-radius: 0px; will-change: unset; position: absolute !important; top: 0px; bottom: 0px; left: 0px; right: 0px; background: #f5f5f5; padding-bottom: 0px;'
            : 'margin-top: 10px !important; width: 590px; max-width: 590px;'}
          closeButtonStyle="top: 0px; position: absolute; top: 7px; right: 9px;"
          mobile={true}
          showCloseButton={!mobile}
          show={showModal}
          fadeInDuration={200}>
          <div slot="content">
            <Mobile
              customGroupStore={customGroupStore}
              recObject={recObject}
              close={close}
              copyLink={copyLinkForMobile}
              goToWeblink={goToWeblink}
              goToEmail={goToEmail}
              goToInstagram={goToInstagram}
              goToPhone={goToPhone}
              showActionBar={showActionBar}
              showBookmark={showBookmark} />
          </div>
        </Modal>
      {/if}

      {#if desktop}
        <Modal
          hide={close}
          style="border-radius: 16px; max-width: 1104px; height: 686px; overflow-y:
      hidden; margin-left: 20px; margin-right: 20px;"
          closeButtonStyle="top: 0px; position: absolute; top: 7px; right: 9px;"
          mobile={false}
          show={showModal}
          fadeInDuration={200}>
          <div slot="content">
            <Desktop
              customGroupStore={customGroupStore}
              showActionBar={showActionBar}
              showShareCard={showShareCard}
              showBookmark={showBookmark}
              recObject={recObject}
              close={close}
              copyLink={copyLinkForDesktop}
              getWeblinkOrAffilateUrl={getWeblinkOrAffilateUrl}
              goToWeblink={goToWeblink}
              goToEmail={goToEmail}
              goToInstagram={goToInstagram}
              goToPhone={goToPhone} />
          </div>
        </Modal>
      {/if}
    </Viewport>

    <input type="text" style="display: none" bind:this={shareInput} value={detailUrl} />
  </div>
{/if}
